import { omit, noop } from 'lodash';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import Isvg from 'react-inlinesvg';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Math3 } from '@hover/machete-primitives';

const HvSvgEventWrapper = styled('div')`
  display: flex;
`;

export default class HvSvg extends PureComponent {
  static propTypes = {
    src: PropTypes.string.isRequired,
    onLoad: PropTypes.func,
    onError: PropTypes.func,
    disabled: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    onLoad: noop,
    onError: noop,
    disabled: true,
    className: '',
  };

  renderIsvg = () => {
    const { src, onLoad, onError, children } = this.props;

    return (
      <Isvg
        src={src}
        wrapper={this.renderWrapper}
        onLoad={onLoad}
        onError={onError}
        uniqueHash={Math3.generateUUID()}
        cacheGetRequests
      >
        {children || <img src={src.replace('.svg', '.png')} />}
      </Isvg>
    );
  };

  renderWrapper = ({ dangerouslySetInnerHTML }) => {
    const wrapperProps = omit(this.props, [
      'src',
      'onLoad',
      'onError',
      'children',
    ]);

    return (
      <HvSvgEventWrapper
        {...wrapperProps}
        className="hv-svg-event-wrapper"
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      />
    );
  };

  render() {
    const { className, disabled } = this.props;
    const svgClass = classNames('hv-svg', className, { disabled });

    return <div className={svgClass}>{this.renderIsvg()}</div>;
  }
}
